import uuid from 'uuid';
import { createSelector } from 'reselect';
import { getUser } from 'store/services/session/selectors';

export const getAccounts = ({ accounts }) => accounts.list.data;

export const getSelectedAccountSelector = createSelector(
  getAccounts,
  getUser,
  (accounts, user) =>
    accounts.find(({ name }) => name === user.username) || {
      name: user.username,
      slug: user.account_slug,
    },
);

export const getIsLoading = ({ accounts }) => accounts.list.isLoading;

export const getAccountsWithIds = createSelector(
  getAccounts,
  accounts =>
    accounts.map(account => ({
      ...account,
      id: uuid(),
    })),
);
